import createIcon from '../../createIcon';

/**
 * @component @name Air
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAxNy41QzE0LjUgMTkuMTUgMTMuMTUgMjAuNSAxMS41IDIwLjVDOS44NSAyMC41IDguNSAxOS4xNSA4LjUgMTcuNUgxMC41QzEwLjUgMTguMDUgMTAuOTUgMTguNSAxMS41IDE4LjVDMTIuMDUgMTguNSAxMi41IDE4LjA1IDEyLjUgMTcuNUMxMi41IDE2Ljk1IDEyLjA1IDE2LjUgMTEuNSAxNi41SDJWMTQuNUgxMS41QzEzLjE1IDE0LjUgMTQuNSAxNS44NSAxNC41IDE3LjVaTTE5IDdDMTkgNS4wNyAxNy40MyAzLjUgMTUuNSAzLjVDMTMuNTcgMy41IDEyIDUuMDcgMTIgN0gxNEMxNCA2LjE3IDE0LjY3IDUuNSAxNS41IDUuNUMxNi4zMyA1LjUgMTcgNi4xNyAxNyA3QzE3IDcuODMgMTYuMzMgOC41IDE1LjUgOC41SDJWMTAuNUgxNS41QzE3LjQzIDEwLjUgMTkgOC45MyAxOSA3Wk0xOC41IDExLjVIMlYxMy41SDE4LjVDMTkuMzMgMTMuNSAyMCAxNC4xNyAyMCAxNUMyMCAxNS44MyAxOS4zMyAxNi41IDE4LjUgMTYuNVYxOC41QzIwLjQzIDE4LjUgMjIgMTYuOTMgMjIgMTVDMjIgMTMuMDcgMjAuNDMgMTEuNSAxOC41IDExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Air = createIcon('Air', [
  [
    'path',
    {
      d: 'M14.5 17.5C14.5 19.15 13.15 20.5 11.5 20.5C9.85 20.5 8.5 19.15 8.5 17.5H10.5C10.5 18.05 10.95 18.5 11.5 18.5C12.05 18.5 12.5 18.05 12.5 17.5C12.5 16.95 12.05 16.5 11.5 16.5H2V14.5H11.5C13.15 14.5 14.5 15.85 14.5 17.5ZM19 7C19 5.07 17.43 3.5 15.5 3.5C13.57 3.5 12 5.07 12 7H14C14 6.17 14.67 5.5 15.5 5.5C16.33 5.5 17 6.17 17 7C17 7.83 16.33 8.5 15.5 8.5H2V10.5H15.5C17.43 10.5 19 8.93 19 7ZM18.5 11.5H2V13.5H18.5C19.33 13.5 20 14.17 20 15C20 15.83 19.33 16.5 18.5 16.5V18.5C20.43 18.5 22 16.93 22 15C22 13.07 20.43 11.5 18.5 11.5Z',
      key: 'yoor6m',
    },
  ],
]);

export default Air;
